import React from "react";

export const DotCoinIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="dcg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2DD4BF" />
        <stop offset="1" stopColor="#0F8A7D" />
      </linearGradient>
    </defs>
    <circle cx="16" cy="16" r="15" fill="#0F2A5F" />
    <circle cx="16" cy="16" r="12" fill="url(#dcg)" />
    <circle cx="16" cy="16" r="9.5" fill="none" stroke="#0F2A5F" strokeOpacity="0.35" strokeWidth="1" />
    <path d="M12 10.5h4.2a5.5 5.5 0 0 1 0 11H12z" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinejoin="round" />
    <circle cx="16.4" cy="16" r="1.6" fill="#fff" />
  </svg>
);

export default DotCoinIcon;
